import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import {Descriptions, Input, Menu, Select, Tooltip, Alert, Icon} from 'antd';
import {isEmpty} from '../../util/isEmpty';
import CustomDropdownRender from '../common/CustomDropdownRender';
import {sortArrObjStr} from '../../util/sortArrObjStr';
import {Button} from "react-bootstrap";
import "../../CSS/Grid.css"
import PopUp from "./PopUp.js";
import {Create_New_Factory, Update_Factory_select, Update_In_Existing_Factory} from "../../actions";
import { findCountry, getPostalCode } from '../../util/getPostalCode.js';
import AddressField from './AddressField.js';
import debounce from 'lodash.debounce';

import { getCountryCode } from '../../util/countryList.js';
import { isValidPostalCode } from '../../util/getPostalCode.js';
const {SubMenu} = Menu;
const {Option} = Select;

const PICKUP = 'pickup';
const DELIVERY = 'delivery';

// selected existing factory fields
const BUSINESS_NAME = 'name';
const EMAIL = 'email';
const POSTAL = 'postal';
const COUNTRY = 'Country';
const CITY = 'city';
const ADDRESS = 'address';
const PORT = 'port';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';

const BUSINESS_TYPE = 'busines_type';
const locationType = [{key: 'warehouse', title: 'Warehouse'}, {
    key: 'businesswithliftgate',
    title: 'Business with Lift Gate'
}, {key: 'businesswithloadingdock', title: 'Business with Loading Dock'}, {
    key: 'residential',
    title: 'Residential'
}, {key: 'port', title: 'Port'},];

/**
 * @component
 * @category Form Page
 * @name ExistingFactoryDescForm
 * @description Existing factory description form on pickup/delivery section
 * <br> <br>
 * **Example**
 * ```js
 *   <ExistingFactoryDescForm isPickupMode={true} portsJSON={{}} myCountries={[]} selectedFactoryJson={{}} handleSelectExistingNewPort={()=>{}}/>
 * ```
 */
class ExistingFactoryDescForm extends Component {

    // instance field to hold our timer
    postalDebounceTimer = null
    constructor(props) {
        super(props);
    this.state = {
        first_render: false,
        Pickup_country: {},
        name: "",
        email: "",
        // postal: "",
        postal: props.selectedFactoryJson?.postal
        || props.postalCode
        || "",
        postalDirty: false,
        city: "",
        address: "",
        contact_name: "",
        phone_number: "",
        busines_type: "",
        form_click: {
            MessageType: "", MessageDescription: "",
            name:"",
            email:"",
            port:""
        },
        popUpDisplay: false,
        saveClicked: false,
        Selected_country: {
            Country: "", Ports: [], Port: {},
        },
        final_details:{},
        regEmail: /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/i
    }
}

    componentDidMount() {
        if (!this.state.first_render || this.props.state_change) {
            this.GroupObject(this.props.originPortJSON, this.props.myCountries, this.props.portsJSON);
            this.update_state_for_form(this.props.selectedFactoryJson);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.transaction_type !== this.props.transaction_type) {
            this.update_state_for_form(this.props.selectedFactoryJson);
        }

        if (
            prevProps.selectedFactoryJson !== this.props.selectedFactoryJson ||
            prevProps.selectedFactoryJson?.id !== this.props.selectedFactoryJson?.id
        ) {
            this.update_state_for_form(this.props.selectedFactoryJson);
        }

        if (!this.state.first_render || this.props.state_change) {
            this.GroupObject(this.props.originPortJSON, this.props.myCountries, this.props.portsJSON);
            this.update_state_for_form(this.props.selectedFactoryJson);
        }
         if (
            prevProps.selectedFactoryJson?.postal !==
            this.props.selectedFactoryJson?.postal
          ) {
            this.setState({
              postal: this.props.selectedFactoryJson.postal || "",
              postalDirty: false
            });
          }
        
          // if the parent-derived postalCode prop changed & user hasn’t typed, sync it
          if (
            prevProps.postalCode !== this.props.postalCode &&
            !this.state.postalDirty
          ) {
            this.setState({ postal: this.props.postalCode || "" });
          }
    }

    componentWillUnmount() {
        clearTimeout(this.postalDebounceTimer)
    }

    restoreFieldIfEmpty = (fieldKey, originalKey = fieldKey) => {
        if (this.state.saveClicked) {
            return;
        }
        const currentValue = this.state[fieldKey];
        const originalValue = this.props.selectedFactoryJson?.[originalKey];
        if (
            (currentValue === '' || currentValue === null || currentValue === undefined) &&
            originalValue
        ) {
            this.setState({
                [fieldKey]: originalValue,
                ...(fieldKey === 'postal' ? { postalDirty: false } : {}),
            });
        }
    };

    onPostalCodeChange = async (postalCode, new_factory) => {
        const {fclItem, lclItem, airItem, queryParams, isPickupMode, selectedFactoryJson, transaction_type} = this.props
        const correctJsonItem = (!isEmpty(fclItem) && fclItem) || (!isEmpty(lclItem) && lclItem) || (!isEmpty(airItem) && airItem) || {};
        // console.log("correctJsonItem",correctJsonItem,"selectedFactoryJson: ",selectedFactoryJson)
        //check if rate is from ECU api (LCL) or FCL
        let isRateFromECUApi = (
            //correctJsonItem?.dataSource === "api" && 
            //(correctJsonItem?.carrier?.scac_code === "ECUW" || correctJsonItem?.carrier?.scacCode === "ECUW") && 
            queryParams?.type === "api-lcl")
        let isFCLRate = queryParams?.type === "api-fcl"
        // console.log("==== isRateFromECUApi ====",isRateFromECUApi)
    
        const country = findCountry(selectedFactoryJson?.country, queryParams?.from?.country, queryParams?.to?.country, isPickupMode, transaction_type)
        
        // Different country validation for LCL vs FCL
        let apiCountryCheck;
        if (isFCLRate) {
            // FCL: only USA and Canada are supported
            apiCountryCheck = ['usa', 'us', 'canada', 'ca'].includes(country.trim().toLowerCase())
        } else {
            // LCL: exclude Bangladesh and Pakistan
            apiCountryCheck = !['bangladesh','bd','pakistan','pk'].includes(country.trim().toLowerCase())
        }

        //console.log("....... Does not Belongs to BD or PK.......... :",apiCountryCheck)
        const countryCode = getCountryCode(country);
        // console.log("countryCode: ",countryCode, "isValidPostalCode: ",await isValidPostalCode(postalCode, countryCode))
        const isValid = await isValidPostalCode(postalCode, countryCode);
        // console.log("is postal code Valid: ",isValid);
        if (!isValid && postalCode) {
            if (isPickupMode) {
                this.props.resetPickupChargesOnly(correctJsonItem.id, queryParams.type);
                this.props.setPickupChargeError(correctJsonItem.id, `Invalid postal code for the pickup location in ${country}`, queryParams.type);
            } else {
                this.props.resetDeliveryChargesOnly(correctJsonItem.id, queryParams.type);
                this.props.setDeliveryChargeError(correctJsonItem.id, `Invalid postal code for the delivery location in ${country}`, queryParams.type);
            }
            return;
        }
        if (isPickupMode) {
            this.props.setPickupPostalCode(postalCode); // <-- Dispatch pickup postal
            this.props.setPickupChargeError(correctJsonItem.id, '', queryParams.type);
          } else {
            this.props.setDeliveryPostalCode(postalCode); // <-- Dispatch delivery postal
            this.props.setDeliveryChargeError(correctJsonItem.id, '', queryParams.type);
          }

         try {
          if((isRateFromECUApi || isFCLRate) && apiCountryCheck){
            // console.log("---FCL / LCL ---",isPickupMode);
             const itemJsonId = correctJsonItem.id || null
             const uuid = correctJsonItem.uuid || null
             const mode = isPickupMode ? "pickup" : "delivery";
             const optionSource = isPickupMode
               ? correctJsonItem?.pickup_section?.find((opt) => opt?.fetch_zip_code)
               : correctJsonItem?.delivery_section?.find((opt) => opt?.fetch_zip_code);
             const optionId = optionSource?.id || "0";
             let tempPostalObj = {
               itemJsonId, //fcl/lcl/air item json id
               uuid,
               mode,
               optionMode: mode,
               zipCode: postalCode,
               optionId,
               option: optionSource || {},
               applyToAllMatching: !new_factory,
               prepaidCollect: correctJsonItem?.prepaidCollect,
               // add origin
               origin: { selectedPort: queryParams?.from?.name, country: queryParams?.from?.country, },
               destination: { selectedPort: queryParams?.to?.name, country: queryParams?.to?.country},
               ers_location: { selectedPort: correctJsonItem?.ers_location},
               ersChecked: correctJsonItem?.ers_checked
             };
              // Start the loading spinner
              this.props.onPostalLoadingChange(true); 
             //console.log("tempPostalObj: ",tempPostalObj)
             await this.props.postZipCodeData(tempPostalObj);
           
             // After the request is completed, stop the loading spinner
             this.props.onPostalLoadingChange(false);
             
             // For FCL delivery, only trigger radio option selection if postal code was already present
             if (isFCLRate && !isPickupMode && this.props.selectedFactoryJson?.postal) {
               // Select the "To Door Delivery" option (index 1) to show calculated charges
               setTimeout(() => {
                 if (this.props.onPickupDeliveryErsRadioBtnsChanged) {
                   this.props.onPickupDeliveryErsRadioBtnsChanged('delivery', 1, true);
                 }
               }, 500);
             }
       
             if(!new_factory){
                let updated_details = {
                    "address": this.state.address,
                    "business_type": this.state.busines_type,
                    "city": this.state.city,
                    "contact_name": this.state.contact_name,
                    "country": this.state.Selected_country.Country,
                    "email": this.state.email,
                    "id": this.props.selectedFactoryJson.id,
                    "name": this.state.name,
                    "phone_number": this.state.phone_number,
                    "postal": postalCode,
                    "isExistingFactorySelected": true,
                    "port": this.state.Selected_country.Port
                }
                // console.log("---updated details-----",updated_details)
                // console.log("---- ----- ---isPickupMode: ",isPickupMode,"updated_details.postal",updated_details?.postal)
                this.updateExistingSelectedFacory(updated_details, isPickupMode, new_factory)
             }
           }else{
                if(isPickupMode){
                    const msg = queryParams.type === "api-fcl" ? "Pick up charges not available." : "Pick up charges not available."
                    this.props.setPickupChargeError(correctJsonItem.id, msg, queryParams.type)
                }else{
                    const msg = queryParams.type === "api-fcl" ? "Delivery charges are not available." : "Delivery charges not available."
                    this.props.setDeliveryChargeError(correctJsonItem.id, msg, queryParams.type)
                }
                return;
           }

         } catch (err) {
           console.error("Error fetching charges after manual postal:", err);
           // Stop the loading spinner even if there's an error
           this.props.onPostalLoadingChange(false);
         }
         if (!this.state.postal.trim()) {
            // console.log("clear off when postal is empty.......")
            this.clearPostalCode()
         }
    }

    onPostalInputChange = (postalValue, new_factory) => {
        // skip BD/PK
        const country = this.state.Selected_country.Country || ''
        const isBDorPK = ['bangladesh','bd','pakistan','pk']
          .includes(country.trim().toLowerCase())
        if (isBDorPK) return
    
        this.setState(state => ({
            postal: postalValue,
            postalDirty: true
          }))
    
        // clear any pending lookup
        clearTimeout(this.postalDebounceTimer)
        // if they cleared it out completely, reset charges and bail
        if (postalValue.trim() === '') {
            this.clearPostalCode()
            return
        }
    
        // debounce: wait 2s after the *last* keystroke
        this.postalDebounceTimer = setTimeout(() => {
            this.onPostalCodeChange(postalValue, new_factory)
        }, 2000)
    }



    updateExistingSelectedFacory = (updated_details, isPickupMode, new_factory) =>{
        if (isPickupMode) {
            if(new_factory){
                this.props.Update_Factory_select(updated_details, true)
            }else{
                // this.props.Update_In_Existing_Factory(updated_details, true)
                this.props.Update_Factory_select(updated_details, true)
            }

        } else {
            if(new_factory){
                this.props.Update_Factory_select(updated_details, false)
                // this.props.handleSelectExistingNewPort()
            }else{
                //this.props.Update_In_Existing_Factory(updated_details, false)
                this.props.Update_Factory_select(updated_details, false)
            }
        }
    }

    // This function will be used for updating address
    onAddressInputChange = (addressValue, isPickupMode, new_factory) => {
        // Update the address in the state
        this.setState({ address: addressValue });
        let updated_details = {
            "address": addressValue,
            "business_type": this.state.busines_type,
            "city": this.state.city,
            "contact_name": this.state.contact_name,
            "country": this.state.Selected_country.Country,
            "email": this.state.email,
            "id": this.props.selectedFactoryJson.id,
            "name": this.state.name,
            "phone_number": this.state.phone_number,
            "postal": this.state.postal,
            "isExistingFactorySelected": true,
            "port": this.state.Selected_country.Port
        }
        this.updateExistingSelectedFacory(updated_details, isPickupMode, new_factory)
    };

    // Handler to clear the postal code
    clearPostalCode = () => {
        const {fclItem, lclItem, airItem, queryParams, isPickupMode, selectedFactoryJson} = this.props
        const correctJsonItem = (!isEmpty(fclItem) && fclItem) || (!isEmpty(lclItem) && lclItem) || (!isEmpty(airItem) && airItem) || {};
        // console.log("correctJsonItem",correctJsonItem,"selectedFactoryJson: ",selectedFactoryJson)
        this.setState({ postal: "" });
        if (selectedFactoryJson && selectedFactoryJson.id) {
            const updated_details = {
                ...selectedFactoryJson,
                postal: "",
            };
            this.updateExistingSelectedFacory(updated_details, isPickupMode, false);
        }
        if(isPickupMode){
            this.props.resetPickupChargesOnly(correctJsonItem.id, queryParams.type);
            this.props.setPickupChargeError(correctJsonItem.id, "", queryParams.type)
            this.props.setPickupPostalCode("");
        }else{
            this.props.resetDeliveryChargesOnly(correctJsonItem.id, queryParams.type);
            this.props.setDeliveryChargeError(correctJsonItem.id, "", queryParams.type)
            this.props.setDeliveryPostalCode("");
        }
    };

    OnclickSaveFactoryInfo = async (isPickupMode,new_factory) => {
        const form = {...this.state.form_click}
        this.setState({saveClicked: true})
        if (this.state.Selected_country.Port.id !== undefined &&
            this.state.email !== undefined &&
            this.state.email !== null &&
            this.state.email !== "" &&
            this.state.name !== undefined &&
            this.state.name !== "" &&
            this.state.regEmail.test(this.state.email) 
            ){
            this.setState({form_click: {name:"",email:"",port:""}})

            let updated_details = {
                "address": this.state.address,
                "business_type": this.state.busines_type,
                "city": this.state.city,
                "contact_name": this.state.contact_name,
                "country": this.state.Selected_country.Country,
                "email": this.state.email,
                "id": this.props.selectedFactoryJson.id,
                "name": this.state.name,
                "phone_number": this.state.phone_number,
                "postal": this.state.postal,
                "isExistingFactorySelected": true,
                "port": this.state.Selected_country.Port
            }

            const { fclItem, lclItem, airItem, queryParams } = this.props;
            // correctJsonItem.id may be undefined if all three items are empty (edge case).
            // RESET_PICKUP/DELIVERY_CHARGES_ONLY is safe in that situation: the FCL branch
            // ignores id and clears all cards; the LCL branch does rate.id !== undefined which
            // is true for every real rate, so nothing is cleared (no-op); AIR returns state.
            const correctJsonItem = (!isEmpty(fclItem) && fclItem) || (!isEmpty(lclItem) && lclItem) || (!isEmpty(airItem) && airItem) || {};

            // Only reset charges when the postal code actually changed.
            //
            // this.props.postalCode is the Redux pickup/delivery_postal_code value. It is
            // dispatched by setPickupPostalCode/setDeliveryPostalCode *before* the dray fetch
            // attempt (not after success). However, callFclDrayage always clears existing
            // charges at the start of every fetch, so after any attempt — success or failure —
            // the charges in Redux are already consistent with this.props.postalCode. There is
            // therefore no reachable state where previousPostal === currentPostal yet stale
            // charges from a different postal remain.
            //
            // The factory-change case is also handled correctly: when the user selects a
            // different factory, componentDidUpdate sets this.state.postal to the new
            // factory's postal (resetting postalDirty to false) while this.props.postalCode
            // still reflects the previous postal. The comparison detects the difference and
            // triggers the reset even though postalDirty is false.
            const previousPostal = (this.props.postalCode || "").trim();
            const currentPostal = (this.state.postal || "").trim();
            if (previousPostal !== currentPostal) {
                if (isPickupMode) {
                    this.props.resetPickupChargesOnly(correctJsonItem.id, queryParams.type);
                } else {
                    this.props.resetDeliveryChargesOnly(correctJsonItem.id, queryParams.type);
                }
            }

            if (isPickupMode) {
                if(new_factory){
                    await this.props.Create_New_Factory(updated_details,isPickupMode)
                    updated_details.id= this.props.store_new_id
                    this.setState({final_details:updated_details})
                    this.props.Update_Factory_select(updated_details, true)
                    //this.props.handleSelectExistingNewPort()

                }else{
                    this.props.Update_In_Existing_Factory(updated_details, true)
                    this.props.Update_Factory_select(updated_details, true)
                }

            } else {
                if(new_factory){
                    await this.props.Create_New_Factory(updated_details,isPickupMode)
                    updated_details.id= this.props.store_new_id
                    this.setState({final_details:updated_details})
                    this.props.Update_Factory_select(updated_details, false)
                    // this.props.handleSelectExistingNewPort()
                }else{
                    this.props.Update_In_Existing_Factory(updated_details, false)
                    this.props.Update_Factory_select(updated_details, false)
                }
            }
            form.MessageType = "success"
            form.MessageDescription = "Details have been saved successfully"
            this.setState({popUpDisplay: true})
            this.props.set_form_error_display(false);
            setTimeout(() => {
                this.setState({ popUpDisplay: false, saveClicked: false });
              }, 2000);
        }
        else
        {
            this.setState({popUpDisplay: false}) 
            form.MessageType = "Error"
            this.props.set_form_error_display(true);
            if (this.state.Selected_country.Port.id === undefined) {
                form.port = "Please enter Port Details"
            }else if(this.state.name===undefined || this.state.name==="" || this.state.name === null){
                form.name = "Please enter business name"
            }
            else if (this.state.email===undefined || this.state.email === null ||  this.state.email==="" || !this.state.regEmail.test(this.state.email)) {
                if (isPickupMode) {
                    form.email = "Please enter valid shipper Email"
                } else {
                    form.email = "Please enter valid Factory Email"
                }
            } else {
                form.MessageType = "error"
                form.MessageDescription = "Server Error,Error code-0013. Please provide this to Prime Freight"
                this.setState({popUpDisplay: true})
                setTimeout(() => {
                    this.setState({ popUpDisplay: false, saveClicked: false });
                  }, 2000);
            }
        }

        this.setState({form_click: form})
    }


    // onExistingFactorySelectChange = (id,event) => {
    //     let selected_company={
    //         "id":id,
    //         "name":event.key
    //     }

    //     const {
    //         isPickupMode,
    //         pickupExistingFactoryJson,
    //         deliveryExistingFactoryJson,
    //     } = this.props;

    //     //
    //     const existingFactoryJson = isPickupMode
    //         ? pickupExistingFactoryJson
    //         : deliveryExistingFactoryJson;



    //     const selectedFactoryJson = existingFactoryJson.filter((value,index)=>{
    //         if(value.id===selected_company.id){
    //             return value
    //         }
    //     })

    //         this.props.Update_Factory_select(selectedFactoryJson[0],isPickupMode)

    // };


    // handleSaveDetails = () => {
    //     if(Object.keys(this.state.final_details).length > 0){
    //         if(this.props.isPickupMode){
    //             this.props.Update_Factory_select(this.state.final_details, true)

    //         }else {
    //             this.props.Update_Factory_select(this.state.final_details, false)
    //         }

    //         let object={
    //             "key":this.state.final_details.name
    //         }
    //         this.onExistingFactorySelectChange(this.state.final_details.id,object)
    //         // this.props.onExistingFactorySelectChange(this.state.final_details.id,object)

    //     }
    // }



    /**
     * @description it updates selected existing factory data. [Read more]{@link module:form_action~updatePickupDeliverySelectedExistingFactory}
     * <br> <br>
     * **updateSelectedExistingFactoryjson(inputObj) -> {void}**
     * <br><br>
     * **Parameters:**
     * | Name          | Type          | Description  |
     * | :------------ |:------------- | :------------|
     * | inputObj      | Object        | data to be updated e.g. `{country: "Austria"}` |

     * Returns: Type: void
     */
    updateSelectedExistingFactoryjson = (eve) => {
        let property_name = Object.keys(eve)
        let JSON = eve[property_name]
        let property_final_name = property_name[0]
        const updatedObjectCountry = {...this.state.Selected_country};

        if (property_final_name === "Country") {
            let selected_ports = []
            updatedObjectCountry.Country = JSON
            updatedObjectCountry.Port = {}
            selected_ports = this.Set_State_for_Port_And_Country(JSON)
            updatedObjectCountry.Ports = selected_ports
            this.setState({
                Selected_country: updatedObjectCountry
            })
            this.setState({address: ""})
            this.setState({city: ""})
            this.setState({postal: ""})

        } else if (property_final_name === "port") {
            updatedObjectCountry.Port = JSON
            this.setState({
                Selected_country: updatedObjectCountry
            })
        } else {
            this.setState({[property_final_name]: JSON})
        }
        const {isPickupMode} = this.props;


    };

    update_state_for_form = (selectedFactoryJson) => {
        if (selectedFactoryJson !== undefined) {
            this.setState({city: selectedFactoryJson.city})
            this.setState({postal: selectedFactoryJson.postal})
            this.setState({name: selectedFactoryJson.name})
            this.setState({email: selectedFactoryJson.email})
            this.setState({address: selectedFactoryJson.address})
            this.setState({busines_type: selectedFactoryJson.business_type})
            this.setState({contact_name: selectedFactoryJson.contact_name});
            this.setState({phone_number: selectedFactoryJson.phone_number});
            if(!this.props.new_factory && !this.props.state_change && this.props.state_change !== undefined){
                this.setState({form_click:{MessageType : "success",MessageDescription : "Details have been saved successfully"}})
                this.setState({popUpDisplay:true})
                setTimeout(() => {
                    this.setState({ popUpDisplay: false, saveClicked: false });
                }, 2000);
            }else {
                this.setState({form_click: {}})
                this.setState({popUpDisplay:false, saveClicked: false})
            }
        }
    }


    Set_State_for_Port_And_Country = (myCountry) => {
        let selected_port = []
        Object.keys(this.state.Pickup_country).find((country, index) => {
            if (country === myCountry) {
                selected_port = this.state.Pickup_country[country]
            }
        })

        return selected_port
    }


    GroupObject = (originPortJSON, myCountries, portsJSON) => {
        this.setState({
            first_render: true
        })

        let country_with_ports = originPortJSON.reduce((groups, obj) => {
            const {Country} = obj;
            if (!groups[Country]) {
                groups[Country] = [];
            }
            groups[Country].push(obj);
            return groups;
        }, {})

        this.setState({
            Pickup_country: country_with_ports
        })

        const updatedObjectCountry = {...this.state.Selected_country};
        updatedObjectCountry.Country = myCountries
        updatedObjectCountry.Port = portsJSON
        let selected_object_ports = {}

        Object.keys(country_with_ports).find((country, index) => {
            if (country === myCountries) {
                selected_object_ports = country_with_ports[country]
            }
        })
        updatedObjectCountry.Ports = selected_object_ports

        this.setState({
            Selected_country: updatedObjectCountry
        })


    }

    render() {
        let {
            portsJSON,
            fclItem,
            lclItem,
            airItem,
            myCountries,
            selectedFactoryJson,
            handleSelectExistingNewPort,
            isPickupMode,
            originPortJSON,
            state_change,
            new_factory,
            postalCode,
            final_view_after_submit
        } = this.props;
        const correctJsonItem = (!isEmpty(fclItem) && fclItem) || (!isEmpty(lclItem) && lclItem) || (!isEmpty(airItem) && airItem) || {};
        portsJSON.Name = portsJSON.name



        //no. of items in a row depending upon screen size
        const descColumn = {xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1};
        return (<div className='bottom-view-form'>
                <Descriptions
                    style={{
                        marginTop: '15px',
                    }}
                    bordered={true}
                    size="small"
                    column={descColumn}>

                    <Descriptions.Item label="Country"
                    >
                        <Select
                            value={this.state.Selected_country.Country || undefined}
                            style={{
                                width: '100%',
                                // maxWidth: window.innerWidth >= 768 && '147px',
                                border: !this.state.Selected_country.Country && '1px solid red',
                                borderRadius: !this.state.Selected_country.Country && '4px',
                            }}
                            placeholder="Select country"
                            onChange={(value) => {
                                this.updateSelectedExistingFactoryjson({
                                    [COUNTRY]: value,
                                });
                            }}
                            dropdownRender={(menu) => (<div>
                                    {myCountries && myCountries.length !== 0 ? (menu) : (<CustomDropdownRender showSpin={true}/>)}
                                </div>)}
                        >
                            {Object.keys(this.state.Pickup_country).map((country) => (
                                <Option key={country} value={country}>
                                    {country}
                                </Option>))}
                        </Select>
                    </Descriptions.Item>

                    {this.state.Selected_country.Ports.length > 0 ? (
                        <Descriptions.Item label={isPickupMode ? 'Port' : 'Destination city'}>
                        <div style={{textAlign:"left"}}>
                            <Select
                                value={this.state.Selected_country.Port.Name}
                                style={{
                                    width:'170px',
                                    // maxWidth: window.innerWidth >= 768 && '147px',
                                    borderRadius: isEmpty(this.state.Selected_country.Port) && '4px',
                                    border: isEmpty(this.state.Selected_country.Port) && '1px solid red',
                                }}
                                placeholder="Select port"
                                onChange={(value) => {
                                    this.updateSelectedExistingFactoryjson({
                                        [PORT]: value,
                                    });
                                }}
                                dropdownRender={(menu) => (<div>
                                        {this.state.Selected_country.Ports.length !== 0 ? (menu) : (
                                            <CustomDropdownRender text="select country first"/>)}
                                    </div>)}
                            >
                                {this.state.Selected_country.Ports.map((port) => (<Option
                                        key={port.id}
                                        value={port}
                                    >
                                        {port.Name}
                                    </Option>))}

                            </Select>
                            </div>
                            {!this.state.Selected_country.Port.Name ? <div className="error-msg">{this.state.form_click.port}</div> : ''} 
                        </Descriptions.Item>) : (<div>

                        </div>)}


                    <Descriptions.Item label="City"
                    >
                        <Input
                            placeholder="Enter city"
                            value={this.state.city}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({[CITY]: e.target.value,})}
                            onBlur={() => this.restoreFieldIfEmpty('city', 'city')}
                            style={{border: !this.state.city && '1px solid red'}}/>
                    </Descriptions.Item>

                    <Descriptions.Item label="Postal">
                        <Input
                            placeholder="Enter postal"
                            value={this.state.postal}
                            // onChange={(e) => this.updateSelectedExistingFactoryjson({
                            //     [POSTAL]: e.target.value,
                            // })}
                            // style={{border: !this.state.postal && '1px solid red'}}

                            // value={this.state.postal || postalCode}
                            onChange={(e) => {
                                // Then, call onPostalInputChange
                                this.onPostalInputChange( e.target.value.trim(), new_factory);
                
                                // First, update the existing factory JSON
                                this.updateSelectedExistingFactoryjson({
                                    [POSTAL]: e.target.value,
                                });
                            }}

                            style={{border: !this.state.postal && '1px solid red', borderRadius: !this.state.postal && '4px',}}
                            allowClear
                        />
                    </Descriptions.Item>

                    {this.props.new_factory ? (<>
                            <Descriptions.Item label="Business Name">
                                <Input
                                    placeholder="Enter Business Name"
                                    value={this.state.name}
                                    onChange={(e) => this.updateSelectedExistingFactoryjson({
                                        [BUSINESS_NAME]: e.target.value,
                                    })}
                                    onBlur={() => this.restoreFieldIfEmpty('name', 'name')}
                                    style={{border: !this.state.name && '1px solid red'}}
                                />
                               {!this.state.name ? <div className="error-msg">{this.state.form_click.name}</div> : ''} 
                            </Descriptions.Item>
                        </>) : (<Descriptions.Item label="Business Name">
                            {this.state.name}
                        </Descriptions.Item>)}


                    <Descriptions.Item label="Business Type">
                    <div style={{textAlign:"left"}}>
                        <Select
                            value={this.state.busines_type || undefined}
                            style={{
                                width: '170px',
                                // maxWidth: window.innerWidth >= 768 && '147px',
                                border: !this.state.busines_type && '1px solid red',
                                borderRadius: !this.state.busines_type && '4px',
                            }}
                            placeholder="Select a business type"
                            onChange={(value) => {
                                // console.log('select loc type val:', value);
                                this.updateSelectedExistingFactoryjson({
                                    [BUSINESS_TYPE]: value,
                                });
                            }}
                        >
                            {Array.isArray(locationType) && sortArrObjStr(locationType, undefined, 'key').map((itemObj) => (
                                <Option key={itemObj.key} value={itemObj.key}>
                                    <Tooltip title={itemObj.title}>{itemObj.title}</Tooltip>
                                </Option>))}
                        </Select>
                    </div>
                    </Descriptions.Item>

                    <Descriptions.Item label="Email">
                        <Input
                            required={true}
                            placeholder="Enter email"
                            value={this.state.email}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [EMAIL]: e.target.value,
                            })}
                            onBlur={() => this.restoreFieldIfEmpty('email', 'email')}
                            style={{
                                border: !(this.state.email || this.state.phone_number) && '1px solid red',
                            }}
                        />
                         { (!this.state.email || this.state.email==="" || !this.state.regEmail.test(this.state.email))  ? <div className="error-msg">{this.state.form_click.email}</div> : ''} 
                    </Descriptions.Item>

                    <Descriptions.Item label="Contact Name">
                        <Input
                            placeholder="Enter contact name"
                            value={this.state.contact_name}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [CONTACT_NAME]: e.target.value,
                            })}
                            onBlur={() => this.restoreFieldIfEmpty('contact_name', 'contact_name')}
                            style={{
                                border: !this.state.contact_name && '1px solid red',
                            }}
                        />
                    </Descriptions.Item>

                    <Descriptions.Item label="Phone Number">
                        <Input
                            placeholder="Enter phone number"
                            value={this.state.phone_number}
                            type={"number"}
                            onChange={(e) => this.updateSelectedExistingFactoryjson({
                                [PHONE_NUMBER]: e.target.value,
                            })}
                            onBlur={() => this.restoreFieldIfEmpty('phone_number', 'phone_number')}
                            style={{
                                border: !(this.state.email || this.state.phone_number) && '1px solid red',
                            }}
                        />
                    </Descriptions.Item>

                    <Descriptions.Item label="Address">
                        <AddressField 
                            name="address" 
                            placeholder="Enter address" 
                            address = {this.state.address}
                            isPickupMode = {isPickupMode}
                            new_factory = {new_factory}
                            onPostalInputChange = {this.onPostalInputChange}
                            onAddressInputChange = {this.onAddressInputChange}
                            onBlur={() => this.restoreFieldIfEmpty('address', 'address')}
                        />
                    </Descriptions.Item> 
                </Descriptions>
                <br></br>
                <Tooltip title="It will save shipper information in database" placement="top">
                    {final_view_after_submit?(
                        <div className="button_save_parent_div"
                             style={{width:"100%"}}
                        >
                            <Button
                                className="button_save"
                                onClick={() => this.OnclickSaveFactoryInfo(isPickupMode, this.props.new_factory)}
                            >
                                Save
                            </Button>
                        </div>
                    ):(
                        <div className="button_save_parent_div">
                            <Button
                                className="button_save"
                                onClick={() => this.OnclickSaveFactoryInfo(isPickupMode, this.props.new_factory)}
                            >
                                Save
                            </Button>
                        </div>
                    )}
                </Tooltip>
                {
                    this.state.saveClicked && this.state.popUpDisplay ?
                   <Alert type={this.state.form_click.MessageType} message={this.state.form_click.MessageDescription} showIcon />
                    : ''
                }

            </div>);
    }
}

ExistingFactoryDescForm.propTypes = {
    /**
     * whether this component is used in pickup section
     */
    isPickupMode: PropTypes.bool, /**
     * origin port json or destination port json on search page
     */
    portsJSON: PropTypes.object, /**
     * list of countries
     */
    myCountries: PropTypes.array, /**
     * selected Existing Factory for pickup/delivery on factory mode
     */
    selectedFactoryJson: PropTypes.object, /**
     * function to handle selected port obj in a single existing factory json
     */
    handleSelectExistingNewPort: PropTypes.func,
};


const mapStateToProps = (state) => {
    return {
        originPortJSON: state.route.originPortJSON.Ports,
        pickupExistingFactoryJson: state.form.pickup.existingFactoryJson,
        deliveryExistingFactoryJson: state.form.delivery.existingFactoryJson,
        showFormValidation: state.form.showFormValidation,
        know_users_details:state.route.User_factor_and_shipper_Details,
        deliveryFactoryInfo: state.form.factoryInfo.delivery,
        pickupFactoryInfo: state.form.factoryInfo.pickup,
        // :state.form.Update_Factory_select,
        selectedPickupExistingFactoryJson:
        state.form.pickup.selectedExistingFactoryJson,
        selectedDeliveryExistingFactoryJson:
        state.form.delivery.selectedExistingFactoryJson,
        final_view_after_submit:state.form.final_view_after_submit,
        store_new_id:state.form.store_new_id,
        transaction_type: state.code_config.transactionType,
        queryParams: state.route.queryParams,
    }
}

export default connect(
    mapStateToProps,
    actions,
    null,
    { forwardRef: true }
  )(ExistingFactoryDescForm);
